var _path, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 38,
    viewBox: "0 0 41 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4253 3.58362C35.4608 3.58362 37.9215 6.04305 37.9215 9.07691V23.7257C37.9215 26.7595 35.4608 29.219 32.4253 29.219H15.7078L9.52453 34.7123V29.219H8.6085C5.57303 29.219 3.1123 26.7595 3.1123 23.7257V9.07691C3.1123 6.04305 5.57303 3.58362 8.6085 3.58362H32.4253ZM32.4254 0.836426H8.60855C4.05535 0.836426 0.364259 4.52557 0.364259 9.07636V23.7251C0.362106 27.5722 3.02365 30.9087 6.77649 31.7636V34.7117C6.77507 35.7955 7.41143 36.7788 8.40103 37.2219C9.39063 37.665 10.5484 37.4851 11.3566 36.7625L16.7612 31.9651H32.4254C36.9786 31.9651 40.6697 28.2759 40.6697 23.7251V9.07636C40.6697 4.52557 36.9786 0.836426 32.4254 0.836426Z",
    fill: "#1977F3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5166,
    cy: 16.4007,
    rx: 1.37405,
    ry: 1.37332,
    fill: "#1977F3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.6778,
    cy: 16.4007,
    rx: 1.37405,
    ry: 1.37332,
    fill: "#1977F3"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.4668,
    cy: 16.4007,
    rx: 1.37405,
    ry: 1.37332,
    fill: "#1977F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReply);
export default __webpack_public_path__ + "static/media/Icon-reply.2690f43aed1a272241eeb660c5e14273.svg";
export { ForwardRef as ReactComponent };